import axios, { AxiosInstance } from "axios";
import { HttpStatusCode } from "../models/HttpStatusCodes";
import { AlertTypes } from "../models/Enums";

interface ApiResponse {
  error: any;
  response: any;
  showLoader: (message?: any) => void;
  clearLoader: () => void;

  showError: (message: any, type: any) => void;
  getError: (error: any) => void;
  showErrors: (errors: any) => void;

  setUploadProgress: (progress: any) => void;
  resetUploadProgress: () => void;
}

interface CustomAxios extends AxiosInstance {
  apiResponse: ApiResponse;
}

const http = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
}) as CustomAxios;

const shouldSkipLoader = (url?: string) => {
  return Boolean(
    url?.includes('/forms/project/verifyName') ||
    url?.includes('/certificates/exports') ||
    url?.includes('/certificates/generateZipFile')
  );
};

http.interceptors.request.use(
    (config) => {
      if (!shouldSkipLoader(config.url)) {
        http.apiResponse.showLoader();
      }
      return config;
    },
    (config) => {
      if (!shouldSkipLoader(config.url)) {
        http.apiResponse.showLoader();

      }
      return config;
    }
)

http.interceptors.response.use(
  (response) => {
    if (!shouldSkipLoader(response.config.url)) {
      http.apiResponse.clearLoader();
    }
    return response;
  },
  (error) => {
    if (!shouldSkipLoader(error.config.url)) {
      http.apiResponse.clearLoader();
    }
    if (error.config.url === '/auth/me/') {
      return undefined;
    }

    throw error;
  }
);

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === HttpStatusCode.Forbidden) {
      window.location.pathname = "/emprendedores/admin/logout";
    }

    if (error.response) {
      http.apiResponse.getError(error);
      return { data: null };
    }

    throw error;
  }
);

http.apiResponse = {
  error: {},
  response: {},
  showLoader: (message: any) => {},
  clearLoader: () => {},
  showError: (message, type) => { },
  setUploadProgress: (progress) => { },
  resetUploadProgress: () => { },
  getError: (error) => {
    if (error.response) {
      let message = `[${error.response.status}] `;
      switch (error.response.status) {
        case HttpStatusCode.BadRequest:
          http.apiResponse.showError(message + error.response.data.error, AlertTypes.ERROR);
          break;
        case HttpStatusCode.InternalServerError:
          http.apiResponse.showError(message + "Internal Server Error.", AlertTypes.ERROR);
          break;

        case HttpStatusCode.NotFound:
          http.apiResponse.showError(message + "Not found", AlertTypes.ERROR);
          break;

        case HttpStatusCode.Unauthorized:
          let url = error.config.url;
          if (url === '/auth/me') {
            break;
          }
          if (url === '/auth/login') {
            http.apiResponse.showError("Usuario o contraseña incorrectos", AlertTypes.ERROR);
            break;
          }
          http.apiResponse.showError(message + error.response.data.error, AlertTypes.ERROR);
          break;

        case HttpStatusCode.Forbidden:
          http.apiResponse.showError(message + "Forbidden", AlertTypes.ERROR);
          break;

        case HttpStatusCode.UnprocessableEntity:
          http.apiResponse.showErrors(error.response.data.errors);
          break;
        default:
          http.apiResponse.showError(message  + error.message, AlertTypes.ERROR);
          break;
      }
    }
  },
  showErrors(errors) {
    // mostrer lista de errores
    let messages: string[] = [];
    for (const key in errors) {
      errors[key].map((error: string) => {
        messages.push(error);
      });
    }

    let element = (
      <div>
        <ul>
          {messages.map((error: string) => (
            <li>{error}</li>
          ))}
        </ul>
      </div>
    );
    http.apiResponse.showError(element, AlertTypes.ERROR);
  },
};


export default http;